import React,{ useState, useEffect, useRef } from "react";
import {
  useNavigate,
  useLocation
} from "react-router-dom";

import { gsap } from "gsap/all";
import { v4 as uuidv4 } from 'uuid';

import { useLoadApi } from './../store/preloaderstore'
import ManipulationSceneCamera from "./../components/ManipulationSceneCamera"

import StdBtnPrevArrow from '../components/StdBtnPrevArrow'
import StdBtnGenericText from '../components/StdBtnGenericText'
import TotalStepsBottom from '../components/TotalStepsBottom'
import BackgroundRoundedUnder from '../components/BackgroundRoundedUnder'
import SpeechBubble from '../components/SpeechBubble'
import TopSpace from '../components/TopSpace'

const axios = require('axios').default;
const ls = require('local-storage');

export default function EditMoustachePage() {
  let navigate = useNavigate();

  const page = useRef(null);
  const mscene = useRef(null);
  const bgUnder = useRef(null);
//  const bubble2 = useRef(null);
  const tpSpace = useRef(null);
  
  const btnWrap = useRef(null);
  const btnPrev = useRef();
  const btnNext = useRef();
  
  useEffect(() => {
    setBGRemImage()
    bgUnder.current.update()
    tpSpace.current.update()

    mscene.current.showBubblePlaceMoustage()
    
    adjustIframeHeight()
  },[]);

  const adjustIframeHeight = () => {
    const ph = gsap.getProperty(page.current,"height")
    console.log(ph)
    if(window !== window.parent) gsap.set(window.parent,{"height":ph})
  }

  const setBGRemImage = () => {
    let imgd = useLoadApi.getState().imgData
    if(imgd) {
      mscene.current.createFromBase64( imgd )
    } else {
      let dest=useLoadApi.getState().getDestURL(),uuid=ls.get("uuid"),u
      if( (""+uuid).length > 10 ) u=dest+"/getremfile/rem-"+uuid+".png"
      else if(window.location.href.indexOf("lentfert")>-1) u = 'http://lentfertnuc/bmlabel/testimg'
      axios.get(u,{
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(res => {
        if(res.data) {
          if(res.data.hasOwnProperty("code") && res.data.code === 200 ) {
            mscene.current.createFromBase64( res.data.imgdata )
          }
        }
      }).catch((error) => {
        console.log(error);
        return error;
      })
    }
  }

  const onPrevious = (ev) => {
    navigate("/editpicture")
  }
  const onNext = (ev) => {
    navigate("/editskintone")
  }

  return (
    <div className="page" ref={page}>
{/*
      <SpeechBubble nr={2} className="speechbubble4" ref={bubble2}>
        <div className="text">
        move, scale<br />
        and rotate
        </div>
      </SpeechBubble>
 */}      
      <ManipulationSceneCamera 
        className="cwrapcam"
        zIndex={7}
        foto={false} 
        editmode={true} 
        editfoto={true} 
        editmoustache={true} 
        autoTouch={false}
        yoffset={0} 
        ref={mscene} 
      />
      
      <TopSpace noMouseOrTouch={true} className="" ref={tpSpace} />
      <div className="txtSkintone">become a true moretti</div>
      <div className="skintone-mid">
        <div className="btnstwrapper" ref={btnWrap}>
          <StdBtnPrevArrow className="btnprev dropshadow-bottom" caption="" onClick={onPrevious} ref={btnPrev} />
          <StdBtnGenericText className="btnnext dropshadow-bottom" caption="NEXT" onClick={onNext} ref={btnNext} />
        </div>
      </div>
      <TotalStepsBottom currentStep={3} />
      <br />
      <br />

      <BackgroundRoundedUnder ref={bgUnder} />
      <div className="bg-img-blur"><img src="gfx/bg-blurred.webp" className="inner" style={{marginTop:"-150px"}} /></div>

    </div>
  );
}
